export function formatoFechaSpanish (fecha) {
  if (fecha != "" && fecha!= null && fecha!= undefined) {
  var anio = fecha.substring(6, 6);
  var mes = fecha.substring(3, 2);
  var dia = fecha.substring(0, 2);
  
    try {
      var m = new Date(fecha);
      var dateString =
        ("0" + m.getDate()).slice(-2) +
        "-" +
        ("0" + (m.getMonth() + 1)).slice(-2) +
        "-" +
        m.getFullYear();
      return dateString;
    } catch (error) {
      console.error(error);
    }
  } else {
    return "";
  }
}
export function formatoFecha(fecha) {
    if (fecha == null) {
      return null;
    } else {
      if ((fecha != "") & (fecha != "0001-01-01T00:00:00")) {
        try {
          var m = new Date(fecha);
          var dateString =
            m.getUTCFullYear() +
            "-" +
            ("0" + (m.getUTCMonth() + 1)).slice(-2) +
            "-" +
            ("0" + m.getUTCDate()).slice(-2);
          return dateString;
        } catch (error) {
          console.error(error);
        }
      } else {
        return "";
      }
    }
  }

   //format datetime to dd/mm/yyyy hh:mm:ss
  export function formatoFechaHoras(date) {
    //console.log(date);
    if (date == null) {
      return "";
    }
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear(),
      hour = d.getHours(),
      minute = d.getMinutes(),
      second = d.getSeconds();

    if (month < 10) month = "0" + month;
    if (day < 10) day = "0" + day;
    if (hour < 10) hour = "0" + hour;
    if (minute < 10) minute = "0" + minute;
    if (second < 10) second = "0" + second;

    return (
      [day, month, year].join("/") + " " + hour + ":" + minute + ":" + second
    );
  }


  export function formatoNumero(num) {
    if (num === null || num == undefined || num === "" || isNaN(num)) {
      return "0.00";
    }

    //contamos la cantidad de puntos sin match
    var puntos = (num.toString().match(/\./g) || []).length;
    //contamos la cantidad de comas
    var comas = (num.toString().match(/\,/g) || []).length;
    //si hay mas de una coma
    if (comas > 0) {
      if (puntos > 0) {
        num = num.replace(/\./g, "");
        num = num.replace(/\,/g, ".");
      } else {
        num = num.replace(/\,/g, ".");
      }
    }
    try {
      num = parseFloat(num);
    } catch (error) {
      return num;
    }

    return num.toLocaleString("es-BO", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  export function formatoNumeroPorcentaje(num) {
    //contamos la cantidad de puntos sin match
    var puntos = (num.toString().match(/\./g) || []).length;
    //contamos la cantidad de comas
    var comas = (num.toString().match(/\,/g) || []).length;
    //si hay mas de una coma
    if (comas > 0) {
      if (puntos > 0) {
        num = num.replace(/\./g, "");
        num = num.replace(/\,/g, ".");
      } else {
        num = num.replace(/\,/g, ".");
      }
    }
    try {
      num = parseFloat(num);
    } catch (error) {
      return num;
    }

    var a= num.toLocaleString("es-BO", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    return a + "%";
  }

  export function quitarFormatoNumero(num) {
    var n = num.replace(/\./g, "");
    n = n.replace(/\,/g, ".");
    //console.log("quitar " + n);
    return n;
  }



  export function obtenerIndicePorID(objeto,id) {
    for (var i = 0; i < objeto.length; i++) {
      if (objeto[i].id === id) {
        return i;
      }
    }
    return -1; // Retorna -1 si no se encuentra el ID en el array
  }

  
  export function esNulo(elemento) {
    if (elemento ==="" || elemento === null || elemento === undefined)
        return true;
    else 
        return false;
  }

// Funciones para manejo de múltiples roles
export function verificarRol(store, roleName) {
  if (!store.state.usuario) return false;
  
  if (store.state.usuario.roles && Array.isArray(store.state.usuario.roles)) {
    return store.state.usuario.roles.some(role => 
      role.nombre === roleName && role.activo
    );
  } else if (store.state.usuario.rol) {
    return store.state.usuario.rol === roleName;
  }
  
  return false;
}

export function verificarAlgunRol(store, roleNames) {
  if (!store.state.usuario || !Array.isArray(roleNames)) return false;
  
  if (store.state.usuario.roles && Array.isArray(store.state.usuario.roles)) {
    return store.state.usuario.roles.some(role => 
      role.activo && roleNames.includes(role.nombre)
    );
  } else if (store.state.usuario.rol) {
    return roleNames.includes(store.state.usuario.rol);
  }
  
  return false;
}

export function obtenerRolPrincipal(store) {
  if (!store.state.usuario) return '';
  
  if (store.state.usuario.roles && Array.isArray(store.state.usuario.roles)) {
    const rolesActivos = store.state.usuario.roles.filter(r => r.activo);
    return rolesActivos.length > 0 ? rolesActivos[0].nombre : '';
  } else if (store.state.usuario.rol) {
    return store.state.usuario.rol;
  }
  
  return '';
}

export function obtenerRolesActivos(store) {
  if (!store.state.usuario) return [];
  
  if (store.state.usuario.roles && Array.isArray(store.state.usuario.roles)) {
    return store.state.usuario.roles
      .filter(r => r.activo)
      .map(r => r.nombre);
  } else if (store.state.usuario.rol) {
    return [store.state.usuario.rol];
  }
  
  return [];
}
